class MyCustomElement extends HTMLElement {
    constructor() {
        super();
        this.products = [];
        // this.products = [
        //     { id: 1, name: "I'm a product 1", price: "€15.00", discountedPrice: "€15.00", image: "https://via.placeholder.com/210x210", ribbon: "Top Sellers" },
        //     { id: 2, name: "I'm a product 2", price: "€15.00", discountedPrice: "€15.00", image: "https://via.placeholder.com/210x210", ribbon: "" },
        //     { id: 3, name: "I'm a product 3", price: "€15.00", discountedPrice: "€14.00", image: "https://via.placeholder.com/210x210", ribbon: "" },
        //     { id: 4, name: "I'm a product 4", price: "€20.00", discountedPrice: "€20.00", image: "https://via.placeholder.com/210x210", ribbon: "Top Sellers" },
        //     { id: 5, name: "I'm a product 5", price: "€25.00", discountedPrice: "€25.00", image: "https://via.placeholder.com/210x210", ribbon: "Top Sellers" },
        //     { id: 6, name: "I'm a product 6", price: "€30.00", discountedPrice: "€30.00", image: "https://via.placeholder.com/210x210", ribbon: "" },
        // ];
        this.currentIndex = 0;
        this.productsPerPage = 3; // Default, will be updated based on container width

        this.maxProducts = 5;
        this.hoverAction = 'quick-view';
        this.hoverText = 'Quick View';
        this.hoverFont = 'Arial';
        this.hoverFontSize = '14px';
        this.hoverFontWeight = 'bold';
        this.hoverColor = '#333';

        this.headingText = 'Recently Viewed Products';
        this.headingFont = 'Arial';
        this.headingFontSize = '24px';
        this.headingColor = '#000';
        this.headingAlignment = 'center';

        this.navButtonColor = 'rgb(18, 18, 18)';
        this.navButtonHoverColor = 'rgb(85, 85, 85)';

        this.enableImageScaling = true;
        this.imageScaleRatio = 1.2;

        this.ribbonEnabled = true;
        this.ribbonFont = 'Arial';
        this.ribbonFontSize = '12px';
        this.ribbonFontWeight = 'bold';
        this.ribbonTextColor = '#FFFFFF';
        this.ribbonBackgroundColor = '#2d9cdb';

        this.discountFont = 'Arial';
        this.discountFontSize = '14px';
        this.discountFontWeight = 'bold';
        this.discountColor = '#E60023';

        this.originalPriceFont = 'Arial';
        this.originalPriceFontSize = '12px';
        this.originalPriceFontWeight = 'normal';
        this.originalPriceColor = '#888888';
        this.originalPriceStrokeColor = '#888888';

        this.productNameFont = 'Arial';
        this.productNameFontSize = '16px';
        this.productNameFontWeight = 'bold';
        this.productNameColor = '#333333';
    }

    connectedCallback() {
        this.innerHTML = '';
        if(this.products.length > 0) {
            this.render();
            this.setupStyles();
            const waitForProductsWrapper = (callback, interval = 50, maxAttempts = 50) => {
                let attempts = 0;

                const checkElement = () => {
                    if (this.querySelector('.products-wrapper')) {
                        callback();
                    } else if (attempts < maxAttempts) {
                        attempts++;
                        setTimeout(checkElement, interval);
                    } else {
                        console.warn('products-wrapper element not found after multiple attempts.');
                    }
                };

                checkElement();
            };

            waitForProductsWrapper(() => {
                this.calculateProductsPerPage();
                this.updateProductsDisplay();
            });
            window.addEventListener('resize', () => {
                this.calculateProductsPerPage();
                this.updateProductsDisplay();
            });
        }
    }

    isMobile() {
        return this.productsPerPage == 1;
    }

    calculateProductsPerPage() {
        const container = this.querySelector('.products-wrapper');
        if (container) {
            const containerWidth = container.offsetWidth;
            const productWidth = 230; // 210px width + 20px gap
            this.productsPerPage = Math.max(Math.floor(containerWidth / productWidth), 1); // always display at least 1 product
        } else {
            console.error('Error: .products-wrapper element not found in calculateProductsPerPage');
        }
    }

    updateProductsDisplay() {
        const productsWrapper = this.querySelector('.products-wrapper');
        if (this.querySelector('.products-wrapper')) {
            productsWrapper.innerHTML = '';
            const endIndex = Math.min(this.currentIndex + this.productsPerPage, this.products.length);
            for (let i = this.currentIndex; i < endIndex; i++) {
                productsWrapper.appendChild(this.createProductElement(this.products[i]));
            }
            this.updateNavButtons();
        }
    }

    updateNavButtons() {
        const leftButton = this.querySelector('.nav-button-left');
        const rightButton = this.querySelector('.nav-button-right');
        leftButton.disabled = this.currentIndex === 0;
        rightButton.disabled = this.currentIndex + this.productsPerPage >= this.products.length;
    }

    render() {
        const container = document.createElement('div');
        container.className = 'recently-viewed-container';

        const title = document.createElement('h2');
        title.textContent = this.headingText;
        title.style.fontFamily = this.headingFont;
        title.style.fontSize = this.headingFontSize;
        title.style.color = this.headingColor;
        title.style.textAlign = this.headingAlignment;
        title.className = 'recently-viewed-title';

        container.appendChild(title);

        const productsWrapper = document.createElement('div');
        productsWrapper.className = 'products-wrapper';
        container.appendChild(productsWrapper);

        const leftButton = this.createNavButton('left');
        const rightButton = this.createNavButton('right');

        container.appendChild(leftButton);
        container.appendChild(rightButton);

        this.appendChild(container);
    }

    createNavButton(direction) {
        const button = document.createElement('button');
        button.className = `nav-button nav-button-${direction}`;

        // Create and append the SVG element
        const svgNS = "http://www.w3.org/2000/svg";
        const svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("fill", "currentColor");
        svg.setAttribute("width", "24");
        svg.setAttribute("height", "24");
        svg.classList.add("rN6xZT");

        const path = document.createElementNS(svgNS, "path");
        path.setAttribute("fill-rule", "evenodd");

        if (direction === 'left') {
            path.setAttribute("d", "M15.0729595,5 L15.7800663,5.70710678 L9.41020654,12.074 L15.7800663,18.4363861 L15.0729595,19.1434929 L7.99920654,12.077895 L8.00220654,12.074 L8,12.0717464 L15.0729595,5 Z");
        } else if (direction === 'right') {
            path.setAttribute("d", "M8.70710678,4.99810828 L15.068,11.3651083 L15.0722115,11.3620693 L15.7793183,12.0691761 L15.776,12.0721083 L15.7782433,12.0758831 L15.0711365,12.7829899 L15.069,12.7801083 L8.70710678,19.1434929 L8,18.4363861 L14.361,12.0721083 L8,5.70521506 L8.70710678,4.99810828 Z");
        }

        svg.appendChild(path);
        button.appendChild(svg);

        button.addEventListener('click', () => this.navigate(direction));

        if (this.isMobile()) {
            button.style[direction === 'left' ? 'left' : 'right'] = '-20px';
        }

        return button;
    }

    navigate(direction) {
        if (direction === 'left') {
            this.currentIndex = Math.max(0, this.currentIndex - this.productsPerPage);
        } else if (direction === 'right') {
            this.currentIndex = Math.min(this.products.length - this.productsPerPage, this.currentIndex + this.productsPerPage);
        }
        this.updateProductsDisplay();
    }

    createProductElement(product) {
        const productDiv = document.createElement('div');
        productDiv.className = 'product';

        const imageContainer = document.createElement('div');
        imageContainer.className = 'product-image-container';
        if (this.isMobile()) { // if it's 1 product, we are going to make it smaller a little bit
            imageContainer.style.width = "200px";
            imageContainer.style.height = "200px";
        }

        const link = document.createElement('a');
        link.href = product.url;

        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.name;
        img.className = 'product-image';

        link.appendChild(img);
        imageContainer.appendChild(link);

        if (!this.isMobile() && this.hoverAction !== 'none') {
            if (this.enableImageScaling) {
                productDiv.classList.add('product-desktop');
            }
            const overlay = document.createElement('div');
            overlay.className = 'product-overlay';

            const quickViewText = document.createElement('span');
            quickViewText.className = 'quick-view-text';
            quickViewText.style.color = this.hoverColor;
            quickViewText.style.fontSize = this.hoverFontSize;
            quickViewText.style.fontWeight = this.hoverFontWeight;
            quickViewText.textContent = this.hoverText;

            overlay.appendChild(quickViewText);

            imageContainer.appendChild(overlay);

            overlay.addEventListener('click', (event) => {
                event.stopPropagation();
                // console.log('Product clicked:', product.id);
                if (this.hoverAction == 'quick-view') {
                    this.dispatchEvent(
                        new CustomEvent("quick-view", { detail: product.id })
                    );
                }
                else if (this.hoverAction == 'add-to-cart') {
                    this.dispatchEvent(
                        new CustomEvent("add-to-cart", { detail: product.id })
                    );
                }
            });
        }

        if (product.ribbon && product.ribbon.length > 0 && this.ribbonEnabled) {
            const topSellerBanner = document.createElement('div');
            topSellerBanner.className = 'top-seller-banner';
            topSellerBanner.textContent = product.ribbon;
            topSellerBanner.style.fontFamily = this.ribbonFont;
            topSellerBanner.style.fontSize = this.ribbonFontSize;
            topSellerBanner.style.fontWeight = this.ribbonFontWeight;
            topSellerBanner.style.color = this.ribbonTextColor;
            topSellerBanner.style.backgroundColor = this.ribbonBackgroundColor;
            imageContainer.appendChild(topSellerBanner);
        }

        const infoDiv = document.createElement('div');
        infoDiv.className = 'product-info';

        const name = document.createElement('h3');
        name.textContent = product.name;
        name.className = 'product-name';

        name.style.fontFamily = this.productNameFont;
        name.style.fontSize = this.productNameFontSize;
        name.style.fontWeight = this.productNameFontWeight;
        name.style.color = this.productNameColor;

        const priceContainer = document.createElement('div');
        priceContainer.className = 'price-container';

        if (product.discountedPrice && product.discountedPrice !== product.price) {
            const originalPrice = document.createElement('span');
            originalPrice.textContent = product.price;
            originalPrice.className = 'original-price';
            originalPrice.style.fontFamily = this.originalPriceFont;
            originalPrice.style.fontSize = this.originalPriceFontSize;
            originalPrice.style.fontWeight = this.originalPriceFontWeight;
            originalPrice.style.color = this.originalPriceStrokeColor;
            originalPrice.style.textDecoration = 'line-through'; // Typically, original prices are shown as struck-through

            const discountedPrice = document.createElement('span');
            discountedPrice.textContent = product.discountedPrice;
            discountedPrice.className = 'discounted-price';
            discountedPrice.style.fontFamily = this.discountFont;
            discountedPrice.style.fontSize = this.discountFontSize;
            discountedPrice.style.fontWeight = this.discountFontWeight;
            discountedPrice.style.color = this.discountColor;

            priceContainer.appendChild(originalPrice);
            priceContainer.appendChild(document.createTextNode(' ')); // Adding space between prices
            priceContainer.appendChild(discountedPrice);
        } else {
            const price = document.createElement('span');
            price.textContent = product.price;
            price.className = 'product-price';
            price.style.fontFamily = this.originalPriceFont;
            price.style.fontSize = this.originalPriceFontSize;
            price.style.fontWeight = this.originalPriceFontWeight;
            price.style.color = this.originalPriceColor;
            priceContainer.appendChild(price);
        }

        infoDiv.appendChild(name);
        infoDiv.appendChild(priceContainer);

        productDiv.appendChild(imageContainer);
        productDiv.appendChild(infoDiv);

        return productDiv;
    }

    setupStyles() {
        const style = document.createElement('style');
        style.textContent = `
            .recently-viewed-container {
                font-family: ${this.headingFont};
                max-width: 100%;
                margin: 0 auto;
                padding: 20px;
                position: relative;
            }
            .recently-viewed-title {
                text-align: center;
                margin-bottom: 20px;
                font-size: 24px;
            }
            .products-wrapper {
                display: flex;
                justify-content: center;
                gap: 20px;
                overflow-x: hidden;
                -ms-overflow-style: none;
                scrollbar-width: none;
            }
            .product {
                flex: 0 0 auto;
                width: 210px;
                text-align: center;
                position: relative;
                cursor: pointer;
            }
            .product-image-container {
                position: relative;
                width: 210px;
                height: 210px;
                overflow: hidden;
            }
            .product-image {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
            }
            .product-desktop:hover .product-image {
                transform: scale(${this.imageScaleRatio});
            }
            .product-overlay {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: rgba(255, 255, 255, 0.7);
                display: flex;
                justify-content: center;
                align-items: center;
                height: 0;
                overflow: hidden;
                transition: height 0.3s ease;
            }
            .product:hover .product-overlay {
                height: 40px;
            }
            .quick-view-text {
                color: #333;
                font-size: 14px;
                font-weight: bold;
            }
            .top-seller-banner {
                position: absolute;
                top: 10px;
                left: 0;
                background-color: #2d9cdb;
                color: white;
                padding: 5px 10px;
                font-size: 12px;
                font-weight: bold;
            }
            .product-info {
                margin-top: 10px;
            }
            .product-name {
                font-size: 16px;
                margin: 5px 0;
            }
            .price-container {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 5px;
                font-size: 14px;
            }
            .product-price {
                color: #666;
                margin: 0;
            }
            .original-price {
                text-decoration: line-through;
                color: #999;
            }
            .discounted-price {
                color: #e74c3c;
                font-weight: bold;
            }
            .nav-button {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 30px;
                height: 30px;
                font-size: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 2;
            }
            .nav-button svg {
                display: block;
                fill: ${this.navButtonColor};
            }
            .nav-button:hover svg {
                fill: ${this.navButtonHoverColor};
            }
            .nav-button:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
            .nav-button-left { left: 10px; }
            .nav-button-right { right: 10px; }
            @media (max-width: 400px) {
                .recently-viewed-title {
                    font-size: 17px !important;
                }
            }
        `;
        this.appendChild(style);
    }

    static get observedAttributes() {
        return [
            'data',
            'max-products',
            'hover-action',
            'hover-text',
            'hover-font',
            'hover-font-size',
            'hover-font-weight',
            'hover-color',
            'heading-text',
            'heading-font',
            'heading-font-size',
            'heading-color',
            'heading-alignment',
            'nav-button-color',
            'nav-button-hover-color',
            'enable-image-scaling',
            'image-scale-ratio',
            'ribbon-enabled',
            'ribbon-font',
            'ribbon-font-size',
            'ribbon-font-weight',
            'ribbon-text-color',
            'ribbon-background-color',
            'discount-font',
            'discount-font-size',
            'discount-font-weight',
            'discount-color',
            'original-price-font',
            'original-price-font-size',
            'original-price-font-weight',
            'original-price-color',
            'original-price-stroke-color',
            'product-name-font',
            'product-name-font-size',
            'product-name-font-weight',
            'product-name-color'
        ];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // console.log("attributeChangedCallback", name, newValue);
        if (name === 'max-products') this.maxProducts = newValue;
        if (name === 'hover-action') this.hoverAction = newValue;
        if (name === 'hover-text') this.hoverText = newValue;
        if (name === 'hover-font') this.hoverFont = newValue;
        if (name === 'hover-font-size') this.hoverFontSize = newValue;
        if (name === 'hover-font-weight') this.hoverFontWeight = newValue;
        if (name === 'hover-color') this.hoverColor = newValue;
        if (name === 'hover-background-color') this.hoverBackgroundColor = newValue;
        if (name === 'hover-background-opacity') this.hoverBackgroundOpacity = newValue;
        if (name === 'heading-text') this.headingText = newValue;
        if (name === 'heading-font') this.headingFont = newValue;
        if (name === 'heading-font-size') this.headingFontSize = newValue;
        if (name === 'heading-color') this.headingColor = newValue;
        if (name === 'heading-alignment') this.headingAlignment = newValue;
        if (name === 'nav-button-color') this.navButtonColor = newValue;
        if (name === 'nav-button-hover-color') this.navButtonHoverColor = newValue;
        if (name === 'enable-image-scaling') this.enableImageScaling = newValue === 'true';
        if (name === 'image-scale-ratio') this.imageScaleRatio = parseFloat(newValue);
        if (name === 'ribbon-enabled') this.ribbonEnabled = newValue === 'true';
        if (name === 'ribbon-font') this.ribbonFont = newValue;
        if (name === 'ribbon-font-size') this.ribbonFontSize = newValue;
        if (name === 'ribbon-font-weight') this.ribbonFontWeight = newValue;
        if (name === 'ribbon-text-color') this.ribbonTextColor = newValue;
        if (name === 'ribbon-background-color') this.ribbonBackgroundColor = newValue;
        if (name === 'discount-font') this.discountFont = newValue;
        if (name === 'discount-font-size') this.discountFontSize = newValue;
        if (name === 'discount-font-weight') this.discountFontWeight = newValue;
        if (name === 'discount-color') this.discountColor = newValue;
        if (name === 'original-price-font') this.originalPriceFont = newValue;
        if (name === 'original-price-font-size') this.originalPriceFontSize = newValue;
        if (name === 'original-price-font-weight') this.originalPriceFontWeight = newValue;
        if (name === 'original-price-color') this.originalPriceColor = newValue;
        if (name === 'original-price-stroke-color') this.originalPriceStrokeColor = newValue;
        if (name === 'product-name-font') this.productNameFont = newValue;
        if (name === 'product-name-font-size') this.productNameFontSize = newValue;
        if (name === 'product-name-font-weight') this.productNameFontWeight = newValue;
        if (name === 'product-name-color') this.productNameColor = newValue;
        if (name === 'data') {
            // console.log("attributeChangedCallback!", JSON.parse(newValue));
            this.products = JSON.parse(newValue);
            this.currentIndex = 0;
        }
        this.connectedCallback();
        this.calculateProductsPerPage();
        this.updateProductsDisplay();
    }
}

customElements.define('rv-custom-element', MyCustomElement);